<div
  class="fd-table__inner header-wrap"
  [fdMenuTrigger]="isSortable || isFilterable ? menu : null"
>
  <span class="text-wrapper column-header-{{ columnTitle }}">{{
    columnTitle | uppercase
  }}</span>
  <div class="icons-wrapper">
    @if (property === currentSortProperty || isSortIconVisible) {
      <app-icon
        class="header-icon custom-icon"
        [icon]="ascending ? 'arrow-up-short-wide' : 'arrow-down-wide-short'"
        size="lg"
      ></app-icon>
    }
    @if (_isFilterIconVisible) {
      <app-icon
        class="header-icon custom-icon"
        icon="filter"
        size="lg"
      ></app-icon>
    }
    @if (isActive) {
      <fd-icon class="custom-icon" glyph="navigation-down-arrow"></fd-icon>
    }
  </div>
</div>

<fd-menu #menu [fdCompact]="true" id="interactive-menu">
  @if (isSortable) {
    <li fd-menu-item>
      <a fd-menu-interactive (click)="onSort(true, property)" class="menu-link">
        <app-icon
          icon="arrow-up-short-wide"
          size="lg"
          class="action-icon"
        ></app-icon>
        <span fd-menu-title>Sort Ascending</span>
      </a>
    </li>
  }
  @if (isSortable) {
    <li fd-menu-item>
      <a
        fd-menu-interactive
        (click)="onSort(false, property)"
        class="menu-link"
      >
        <app-icon
          icon="arrow-down-wide-short"
          size="lg"
          class="action-icon"
        ></app-icon>
        <span fd-menu-title>Sort Descending</span>
      </a>
    </li>
  }
  @if (isFilterable) {
    <li fd-menu-item [hasSeparator]="isFilterable">
      <a fd-menu-interactive (click)="onFilter(property)" class="menu-link">
        <app-icon icon="filter" size="lg" class="action-icon"></app-icon>
        <span fd-menu-title>Filter By...</span>
      </a>
    </li>
  }
</fd-menu>
